export const DEMOGRAPHICS_FIELDS = {
  DATE_OF_BIRTH: 'Dem_DOB',
  ETHNIC_GROUP: 'Dem_EthnicGroup',
  FIRST_NAME: 'Dem_FirstName',
  GENDER: 'Dem_Gender',
  LAST_NAME: 'Dem_LastName',
  SEX: 'Dem_Sex',
} as const;
